export enum specimenType {
  Embryo = 'Embryo',
  Semen = 'Semen',
}

export const MARKETPLACE_SPECIMEN_TYPE_FILTER_OPTIONS: ReadonlyArray<{
  specimenTypeId: number;
  name: string;
}> = [
  { specimenTypeId: 1, name: 'Semen' },
  { specimenTypeId: 2, name: 'Embryo' },
];
